import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';


const initialState = {
    gymsList: null,
    gymsListLoading: false
};

export const gymsAction = createAsyncThunk('gymsAction', async (payload, { dispatch }) => {
    dispatch(setGymsListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/class';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setGymsListLoading(false))
                return data

            case 'post':
                ({ data } = await ax.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Зал успешно отредактирован`
                })
                break;

            case 'put':
                ({ data } = await ax.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Зал успешно добавлен`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Зал успешно удален`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setGymsListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const GymsSlice = createSlice({
    name: 'gyms',
    initialState,
    reducers: {
        setGymsListLoading: (state, action) => {
            state.gymsListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(gymsAction.fulfilled, (state, action) => {
            state.gymsList = action.payload
        })
    }
});

export const { setGymsListLoading } = GymsSlice.actions;

export default GymsSlice.reducer